import { memo, useEffect } from "react";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import ".././inner.css";
import { LazyLoadImage } from "react-lazy-load-image-component";

function CongenitalOrtho() {
  useEffect(() => {
    document.title =
      "Congenital Deformities & Growth Related Issues | Viksha Health Care";
    const newMetaDescription =
      "Care for congenital deformities and growth-related orthopaedic issues at Viksha Health Care. Evaluation, guidance, and treatment planning.";
    const metaTag = document.querySelector('meta[name="description"]');
    if (metaTag) {
      metaTag.setAttribute("content", newMetaDescription);
    }
  }, []);

  return (
    <>
      <h2 style={{ fontSize: "0px" }}>
        Congenital Deformities & Growth Related Issues
      </h2>
      <div className="serinfobox">
        <div className="serinfoimg">
          <LazyLoadImage src="/photo/Congenital-Deformities-Growth-Related-Issues.avif" />
        </div>
        <div className="textareaofser">
          <h1>Congenital Deformities & Growth Related Issues</h1>

          <p>
            Congenital deformities and growth-related orthopaedic conditions
            affect the bones, joints, and limbs of children as they grow. These
            conditions may be present at birth or develop during childhood due
            to differences in bone growth and development.
          </p>

          <p>
            Early evaluation and proper management are important to support
            normal growth, prevent complications, and ensure children can move
            comfortably and confidently.
          </p>

          <h5>Common Congenital and Growth-Related Conditions</h5>
          <ul>
            <li>Clubfoot and other foot deformities present at birth</li>
            <li>Bow legs or knock knees</li>
            <li>Limb length differences</li>
            <li>Hip development problems in infants</li>
            <li>Spinal alignment issues in growing children</li>
            <li>Growth plate injuries affecting bone development</li>
          </ul>

          <h5>Signs Parents Should Watch For</h5>
          <ul>
            <li>Uneven walking or persistent limping</li>
            <li>One leg appearing shorter than the other</li>
            <li>Abnormal shape or position of the feet</li>
            <li>Difficulty with balance or coordination</li>
            <li>Back or leg pain in growing children</li>
          </ul>

          <h5>Evaluation and Diagnosis</h5>
          <p>
            Assessment includes a detailed medical history, physical
            examination, and when needed, imaging tests to understand bone
            alignment and growth patterns. Monitoring growth over time helps
            ensure that development is progressing normally.
          </p>

          <h5>Non-Surgical Management</h5>
          <p>
            Many growth-related issues can be managed with observation,
            physiotherapy, corrective exercises, braces, or casts. Early
            treatment can guide proper alignment and improve long-term outcomes.
          </p>

          <h5>Surgical Treatment (When Needed)</h5>
          <p>
            In some cases, surgery may be recommended to correct bone alignment
            or address growth disturbances. Procedures are planned carefully to
            protect growth plates and support healthy development.
          </p>

          <h5>Importance of Regular Follow-Up</h5>
          <p>
            Children grow rapidly, so regular follow-up visits are essential to
            monitor progress and adjust treatment when necessary. Early
            intervention often leads to better functional and cosmetic outcomes.
          </p>

          <h5>Supporting Healthy Growth</h5>
          <p>
            Along with medical treatment, maintaining good nutrition,
            encouraging safe physical activity, and ensuring proper posture can
            help support bone and muscle development.
          </p>

          <p>
            Timely care for congenital deformities and growth-related issues
            helps children achieve better movement, confidence, and overall
            quality of life as they grow.
          </p>
        </div>
      </div>
    </>
  );
}

export default memo(CongenitalOrtho);
